 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		110: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_vi","52":"lang_zh_cn","53":"lang_zh_tw","54":"locale_ak","55":"locale_ar","56":"locale_be","57":"locale_bg","58":"locale_bs","59":"locale_ca","60":"locale_cs","61":"locale_da","62":"locale_de","63":"locale_el","64":"locale_en","65":"locale_es","66":"locale_et","67":"locale_fi","68":"locale_fil","69":"locale_fr","70":"locale_he","71":"locale_hi","72":"locale_hr","73":"locale_hu","74":"locale_id","75":"locale_is","76":"locale_it","77":"locale_ja","78":"locale_ka","79":"locale_kk","80":"locale_ko","81":"locale_ky","82":"locale_lt","83":"locale_lv","84":"locale_nl","85":"locale_pa","86":"locale_pl","87":"locale_pt","88":"locale_ro","89":"locale_ru","90":"locale_sk","91":"locale_sl","92":"locale_sq","93":"locale_sr","94":"locale_sr_cyrl_me","95":"locale_sv","96":"locale_sw","97":"locale_th","98":"locale_tr","99":"locale_uk","100":"locale_ur","101":"locale_vi","102":"locale_zh","103":"loclae_af","104":"polyfills","106":"srcdoc-polyfill","107":"vendors~css-vars-ponyfill","108":"vendors~polyfills"}[chunkId]||chunkId) + "." + {"0":"6f6e288ef3afad74b013","2":"634f4774debedfd27a21","3":"30a49a612c1319418f7e","4":"807e2acd5e9e931b5d20","5":"4d4b367f17b6d7e5f5c5","6":"2f69fc74d803afebf636","7":"1004fb1277e7f6bcdede","8":"362d246b71271ace07bd","9":"df2cb99e3c13fa67dea0","10":"a66d81d0a2a2f6d4d850","11":"88ec8fceefc5f541eaca","12":"7f62aecef76f0321be4c","13":"b13f4abfdb55347ebeea","14":"9f9c58c06266d0b73470","15":"5f1ca4f986cd4f594fda","16":"c8ec8cbeea863df088f9","17":"65ed4721759fee954570","18":"5cce90a30f3161f82f62","19":"cb6bc0a27184c5755427","20":"22f3d8e8542c7acade70","21":"9ba0335cbba477d6487c","22":"f73f8cad0641335a599d","23":"983d47ab74ea49896240","24":"ab4708631bd35bf72844","25":"192a2f57d3eef24cfbc2","26":"3b64ada538849db6fbef","27":"95558725bcf45070260e","28":"cdecd9d2b0a3c75a2f68","29":"ea5a16df0d5c498520b5","30":"3a432d77aad41d4b3211","31":"c678feab22a7dc50bc5e","32":"1fbf5e860b364bf9a02b","33":"8c1e440b7f104969627c","34":"42361af0eb3f25b9b925","35":"c9d57854b87654bf7dab","36":"b2e262dc1b1fa68d8a1a","37":"39fb107ff07b0a41b77b","38":"c9189aa034a84359a8ea","39":"260552061bde5569919c","40":"498ff2440beb84ab6b02","41":"cfe53000126835b32730","42":"fd77f47692d8bd379834","43":"eda5aae903a781fba781","44":"1cbb28cf7d836d719fa1","45":"c3bf02920d0a4fe762c8","46":"52494717426f80431398","47":"bb376962c357e62c62c8","48":"eeefc45d90f589ea1107","49":"01fb2f675c2e6f99c4b5","50":"146bfecba5e987194b47","51":"aff76952d49e11fd9dfb","52":"a84c985c508c07e8e0bb","53":"ae806ea9bcb3cb8f1e59","54":"0d86d4816d950bf8dfbf","55":"5932cb6eb4c86086785a","56":"7d344ece209057690f5b","57":"f17c5475101ba4c8a5a0","58":"a87b5e0de1742a06baf0","59":"12868be3ba79403dbfbd","60":"532633160942a7109fa8","61":"b7f2be961d02d6d28918","62":"57819a6d3a9fdf89c4af","63":"47930a8053d5a86d4716","64":"68de4bef637413f8ce9d","65":"29bf675d556ed1ebf631","66":"2cc8800d19ccb4a4eea0","67":"a061fd8e921d061477d3","68":"e6366937a0d37ff34b6f","69":"d8f237a79a44457ed7cf","70":"931131da45814e6cb6a6","71":"e4cb183e19f60659bf6b","72":"396e06e5be39051a0f8f","73":"f361a0a7d32102241d29","74":"afc2ba7669c569e7e7c1","75":"67e48787d3e2abaf8836","76":"6fd067eefe04b43e60eb","77":"05f63acb09d36a86c133","78":"b5f5a9cb9b00caabbb67","79":"1cbd4f3bdbcfdd44b26b","80":"1c58d1476d96736d9dcc","81":"fa49f2933cd96e12550a","82":"8d2a0abfef14d01b700a","83":"3c770c67729ac38a2b0a","84":"766b73f639ae1a149e68","85":"80e77d7c9684a7df982f","86":"a524a8e5d01618798295","87":"b5b99462ee4853cf58b5","88":"3225ebcfafd539ed38e6","89":"7a8e6b32fea372bc7bb1","90":"afd9ef139c2469ec8be2","91":"9990da736aec8adaa551","92":"aaa41329e5c43aea4c9f","93":"4c6d54286468cf0e25fd","94":"0827e25e282a9c9f26f3","95":"de5cd913d028a45d9bb3","96":"e35a06497e9c65d7d3db","97":"8996904016c1b86301ca","98":"fefb44e4cdc0215fe545","99":"2dd5bd7f9a81c6a1f9db","100":"e8e70806f4d4ba37c197","101":"6a7410799ff143147923","102":"0052009b3a8af0220821","103":"716cb3be04406f1f538d","104":"ae610d987909c9ec252e","106":"c6450f3ca8d7962d571e","107":"9b236a6524b673c7512a","108":"fa65e77a90ff545cf5e2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 76);
